<template>
  <div class="sdg-container">
    <div class="header">
      Finanzen
    </div>
    <div class="content programme-block">

      <div class="programme-item">
        <div class="programme-title">UNSERE VISION #WEIDEN2040</div>
        Unsere Finanzmittel werden zukunftsorientiert und enkeltauglich
        verwendet.
        <br>
        Das erreichen wir durch:
      </div>

      <div class="programme-item">
        <div class="programme-title">Finanzen</div>
        Geld kann man nur einmal ausgeben. Deshalb wollen wir die begrenzten
        Mittel zukunftsorientiert einsetzen. An erster Stelle stehen bei uns
        deshalb Investitionen und laufender Unterhalt für Schulen und
        Einrichtungen für Kinder. Die Fortentwicklung und klare Umsetzung des
        Masterplans „Schulen“ ist ein Beitrag zur Chancengleichheit und zur
        sozialen Gerechtigkeit. Auch die energetische Sanierung der städtischen
        Gebäude und die Schaffung von preiswerten Wohnungen wollen wir
        anpacken.

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sdg05',
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';
</style>
